import { Injectable, TemplateRef } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { scan, startWith } from 'rxjs/operators';

/**
 * @deprecated Use riv-callout instead.
 * @see https://rivethealth.github.io/design-system/?path=/story/lib-modal-callout--example
 */
@Injectable({ providedIn: 'root' })
export class DeprecatedCalloutService {
  private change = new Subject<{
    type: 'add' | 'remove';
    callout: TemplateRef<unknown>;
  }>();

  callouts: Observable<TemplateRef<unknown>[]> = this.change.pipe(
    scan(
      (acc, value) => {
        switch (value.type) {
          case 'add':
            return [...acc, value.callout];
          case 'remove': {
            const index = acc.indexOf(value.callout);
            if (index < 0) {
              return acc;
            }
            return [...acc.slice(0, index), ...acc.slice(index + 1)];
          }
        }
      },
      <TemplateRef<unknown>[]>[],
    ),
    startWith([]),
  );

  add(callout: TemplateRef<unknown>) {
    this.change.next({ type: 'add', callout });
  }

  remove(callout: TemplateRef<unknown>) {
    this.change.next({ type: 'remove', callout });
  }
}
